<div class="login-center">
    <div class="py-0">
        <div class="container">
            <div class="row p-0 m-0">
                <div class="col-md-12 p-2 m-0">
                    <img class="d-block mx-0 p-0 logo-login mx-auto" src="assets/imgs/logo.png">
                </div>
            </div>
            <div class="row p-0 m-0">
                <div class="col-md-12 p-2 m-0">
                    <div class="card text-dark p-0" style="border: none;">
                        <div class="card-body p-0 m-0">
                            <form id="formLogin" class="needs-validation" #f="ngForm" (ngSubmit)="onSubmit(f)">
                                <div class="form-group"> <label class="p-0 mb-1">Usuário</label>
                                    <div class="input-group">
                                        <input ngModel name="usr" type="text" class="form-control" placeholder="Usuário" autocomplete="off" required autofocus>
                                        <div class="input-group-addon addonlogin"><i class="fas fa-at"></i></div>
                                    </div>
                                    <div class="invalid-feedback">{{msgLogin}}</div>
                                </div>
                                <div class="form-group"> <label class="p-0 mb-1">Senha</label>
                                    <div class="input-group">
                                        <input ngModel name="psw" [type]="hidePass ? 'password' : 'text'" class="form-control" placeholder="Senha" autocomplete="off" required aria-describedby="passeye">
                                        <div class="input-group-addon addonlogin" (click)="hidePass = !hidePass" data-toggle="tooltip" title="Exibir senha"><i class="{{hidePass ? 'fas fa-eye-slash' : 'fas fa-eye'}}"></i></div>
                                    </div>
                                </div>
                               <button type="submit" 
                                        name="btEntrar" 
                                        [disabled]="disableBtnEntrar" 
                                        class="btn btn-orange w-100 text-uppercase btn-lg">
                                {{!disableBtnEntrar ? 'Entrar' : 'Aguarde...'}}
                                </button>
                            </form>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>